import {tsParticles} from "@tsparticles/engine";
import {loadSlim} from "@tsparticles/slim";

await loadSlim(tsParticles);

globalThis.tsParticles = tsParticles;

globalThis.startParticles = async (elementId, config) => {
    await tsParticles.load(
        {
            id: elementId,
            options: config
        }
    );

    console.log("particles loaded");
};